module.exports = __webpack_public_path__ + "img/tastingBannerHomeIcon.2e747aba.svg";